__turbopack_context__.v({
  "badgeWrapper": "publication-card-module-scss-module__tbbbsG__badgeWrapper",
  "body": "publication-card-module-scss-module__tbbbsG__body",
  "card": "publication-card-module-scss-module__tbbbsG__card",
  "date": "publication-card-module-scss-module__tbbbsG__date",
  "heading": "publication-card-module-scss-module__tbbbsG__heading",
});
